import { render, staticRenderFns } from "./LotLastBidAmount.vue?vue&type=template&id=8738b9e2&scoped=true&"
import script from "./LotLastBidAmount.vue?vue&type=script&lang=js&"
export * from "./LotLastBidAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8738b9e2",
  null
  
)

export default component.exports